export const GET_VEHICLES_STATED = 'GET_VEHICLES_STATED';
export const GET_VEHICLES = 'GET_VEHICLES';
export const GET_VEHICLES_ENDED = 'GET_VEHICLES_ENDED';
export const ADD_VEHICLE_STATED = 'ADD_VEHICLE_STARTED';
export const ADD_VEHICLE = 'ADD_VEHICLE';
export const ADD_VEHICLE_ENDED = 'ADD_VEHICLE_ENDED';
export const EDIT_VEHICLE_STATED = 'EDIT_VEHICLE_STATED';
export const EDIT_VEHICLE = 'EDIT_VEHICLE';
export const EDIT_VEHICLE_ENDED = 'EDIT_VEHICLE_ENDED';
export const GET_VEHICLE = 'GET_VEHICLE';
export const GET_VEHICLE_STATED = 'GET_VEHICLE_STATED';
export const GET_VEHICLE_ENDED = 'GET_VEHICLE_ENDED';
export const RESET_VEHICLE = 'RESET_VEHICLE';
export const ERROR_VEHICLE = 'ERROR_VEHICLE';
export const GET_ALL_VEHICLES_STATED = 'GET_ALL_VEHICLES_STATED';
export const GET_ALL_VEHICLES = 'GET_ALL_VEHICLES';
export const GET_ALL_VEHICLES_ENDED = 'GET_ALL_VEHICLES_ENDED';
